//import { signalRInstance } from "../api/signalrService";
import myApp from "../main";
export default {
    data() {
        return {
            signalConnection: null,
        }
    },
    mounted() {
        const apiClient = process.env.VUE_APP_SIGNALR_SEVICE
        this.signalConnection = new signalR.HubConnectionBuilder()
            .withUrl(apiClient, {
                accessTokenFactory: async () => {
                    const token = await myApp.$auth.getTokenSilently()
                    return token
                },
                timeoutInMilliseconds:null
            })
            .withAutomaticReconnect([0, 3000, 5000, 10000, 15000, 30000,45000,60000])            
            .configureLogging(signalR.LogLevel.None)
            .build();
    },
    beforeDestroy() {
        if (this.signalConnection && this.signalConnection.connectionState.toLowerCase() === "connected") {
            this.signalConnection.stop();
            this.signalConnection = null;
        }
    },
    methods: {
    }
}